import { TypographyProps } from '@procore/core-react/dist/_typedoc/Typography/Typography.types.json';
import * as React from 'react';
export default {
  TypographyProps,
  React
};